import '../scss/main.scss';
import '@popperjs/core';
import 'bootstrap';
import './prism';
import './app';



function importAll (r) {
    r.keys().forEach(r);
}
importAll(require.context('../../../components/', true, /\.js$/));
//importAll(require.context('../../../templates/', true, /\.js$/));


